module.exports = __webpack_public_path__ + "static/background-top-54937a938e4203b4ab6646fea3b91d8f.svg";